import { Languages, Check } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useI18n } from '@/i18n/I18nProvider';
import { LOCALES, LOCALE_LABELS } from '@/i18n/messages';

export default function LanguageSwitcher({ size = 'sm', className = '' }) {
  const { locale, setLocale, t } = useI18n();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size={size}
          data-testid="language-switcher"
          aria-label={t('language.switch')}
          className={`h-9 px-2.5 rounded-lg text-muted-foreground hover:text-foreground gap-1.5 ${className}`}
        >
          <Languages className="h-4 w-4" />
          <span className="font-mono text-xs tracking-wider">
            {LOCALE_LABELS[locale].short}
          </span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card border border-border">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider text-muted-foreground">
          {t('language.switch')}
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-border" />
        {LOCALES.map((code) => (
          <DropdownMenuItem
            key={code}
            data-testid={`language-option-${code}`}
            onClick={() => setLocale(code)}
            className="flex items-center justify-between cursor-pointer focus:bg-secondary"
          >
            <span className="flex items-center gap-2">
              <span className="font-mono text-[10px] tracking-wider text-muted-foreground w-6">
                {LOCALE_LABELS[code].short}
              </span>
              <span>{LOCALE_LABELS[code].long}</span>
            </span>
            {locale === code && <Check className="h-3.5 w-3.5 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
